import fieldNames from '../../constants/field_names';
import getFieldValueByName from './get_field_value_by_name';

export default function getSpells(form) {
  return getFieldValueByName(form, fieldNames.spells);
}



// WEBPACK FOOTER //
// ./client/app/scripts/leadform/models/form/get_spells.js